/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Status_UnhealthyInputs */



/**
* | output |
* | --- |
* | "Unhealthy" |
*
* @param {Mcp_Servers_Status_UnhealthyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_status_unhealthy = /** @type {((inputs?: Mcp_Servers_Status_UnhealthyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Status_UnhealthyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht erreichbar")
	return /** @type {LocalizedString} */ ("Unhealthy")
});